// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bCBW","title":"styles_title__ugpAr"};